module.exports = __webpack_public_path__ + "img/2.01a8815e.png";